module.exports = __webpack_public_path__ + "0f61ca8e2814c8af6c3393403a0de898.svg";